import Card from "react-bootstrap/Card";
import Badge from "react-bootstrap/Badge";
import Button from "react-bootstrap/Button";

const isExpired = (expirationDate) => {
  if (expirationDate === null) return false;
  let checkDate = new Date(expirationDate);
  checkDate.setDate(checkDate.getDate() + 1);
  return checkDate.getTime() < new Date().getTime();
};

const VoucherCard = ({
  item,
  setShowDeleteConfirmModal,
  setDeleteConfirmData,
  redeemVoucher,
}) => {
  return (
    <Card className="mb-3">
      <Card.Body>
        <Card.Title className="d-flex justify-content-between align-items-start">
          <span>{item.title}</span>
          {item.newlyAdded === true && (
            <Badge
              pill
              className="ms-2"
              bg="warning"
              style={{ color: "#7d5b07" }}
            >
              Neu
            </Badge>
          )}
        </Card.Title>
        <Card.Subtitle>
          <Card.Link href={item.link} target="_blank" rel="noreferrer">
            {item.location}
          </Card.Link>
        </Card.Subtitle>
        {/* <Card.Text className="mt-2"> */}
        <div className="mt-2 mb-3">
          {item.description}
          {item.expiration && (
            <div className="mt-1">
              <i>
                {isExpired(new Date(item.expiration))
                  ? "Abgelaufen am "
                  : "Gültig bis am "}
                {new Date(item.expiration).toLocaleDateString("de", {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                })}
                .
              </i>
            </div>
          )}
          <hr />
          <div className="text-muted d-flex justify-content-between align-items-start">
            <span>
              Herausgegeben von der Gesellschaft zur Förderung der Bierkultur
              (GFB).
            </span>
            <a href="https://bierkultur.org">
              <img
                alt="GFB"
                className="ms-2"
                src="gfb-logo.svg"
                width="54"
                height="40"
              ></img>
            </a>
          </div>
        </div>
        {/* </Card.Text> */}
        <Button
          className="me-2"
          variant="primary"
          onClick={() => redeemVoucher(item.id)}
        >
          Jetzt einlösen
        </Button>
        <Button
          variant="outline-danger"
          onClick={() => {
            setDeleteConfirmData({
              id: item.id,
              title: item.title,
              location: item.location,
            });
            setShowDeleteConfirmModal(true);
          }}
        >
          Löschen
        </Button>
      </Card.Body>
      <Card.Footer className="text-muted" style={{ fontSize: "10px" }}>
        Identifikation: {item.id.substring(0, 8)}
      </Card.Footer>
    </Card>
  );
};

export default VoucherCard;
